import React from "react";

import { ERROR_PAGE_LABELS } from "./constants/labels";
import ErrorHandler from "./error-handler";

const { NO_AUTH } = ERROR_PAGE_LABELS;

const NoAuth = () => {
  return <ErrorHandler errorCase={NO_AUTH} />;
};

export default React.memo(NoAuth);
